/**
 * Date formatting shared by the API (PDF) and the Admin frontend so the two
 * never drift.
 */

const ordinalSuffix = (day: number): string => {
  // 11th/12th/13th are exceptions to the 1st/2nd/3rd pattern.
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Format a date as a human-friendly long date, e.g. "17th August 2025".
 *
 * Date-only values are stored as midnight UTC, so the UTC calendar components
 * are used to avoid a timezone shift moving the day. Returns 'N/A' for
 * null/undefined and for values that do not parse to a real date.
 */
export const formatLongDate = (value: Date | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return 'N/A';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 'N/A';
  const day = date.getUTCDate();
  return `${day}${ordinalSuffix(day)} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
};
